import { render, staticRenderFns } from "./PcCloseIcon.vue?vue&type=template&id=c33ccfc2&scoped=true"
import script from "./PcCloseIcon.vue?vue&type=script&lang=js"
export * from "./PcCloseIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33ccfc2",
  null
  
)

export default component.exports